import React from 'react';
import { motion } from 'framer-motion';
import { BlocksIcon } from 'lucide-react';
export function MechanismSection() {
  return <section className="py-20 md:py-28 px-4 bg-cream relative" data-id="element-138">
      <div className="max-w-4xl mx-auto" data-id="element-139">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-140">
          <div className="inline-flex items-center gap-2 mb-6 px-3 py-1.5 rounded-full bg-sage/10 text-sage-dark text-sm font-medium" data-id="element-141">
            <BlocksIcon className="w-4 h-4" data-id="element-142" />
            El método
          </div>

          <h2 className="text-3xl md:text-5xl lg:text-6xl font-bold leading-[1.05] mb-6 text-warm-900" data-id="element-143">
            El Sistema de <br data-id="element-144" />
            <span className="italic text-sage-dark font-medium" data-id="element-145">
              Ensamblaje Modular
            </span>
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7,
        delay: 0.2
      }} className="bg-white border border-warm-200/60 rounded-3xl p-8 md:p-12 shadow-sm" data-id="element-146">
          <p className="text-lg md:text-xl text-warm-800/90 leading-relaxed mb-6 font-light" data-id="element-147">
            No es un libro de recetas. Es un método para dejar de{' '}
            <em className="text-warm-900" data-id="element-148">"cocinar"</em> platos complejos y
            empezar a{' '}
            <strong className="text-sage-dark font-semibold not-italic" data-id="element-149">
              "ensamblar"
            </strong>{' '}
            piezas maestras.
          </p>

          <div className="h-px w-12 bg-sage/40 my-8" data-id="element-150" />

          <p className="text-lg md:text-xl text-warm-800/90 leading-relaxed font-light" data-id="element-151">
            La filosofía es simple: abres la nevera y el{' '}
            <strong className="text-warm-900 font-semibold" data-id="element-152">
              90% del trabajo ya está hecho
            </strong>
            . Solo tienes que combinar lo que ya está listo.
          </p>

          <div className="mt-8 flex flex-wrap gap-3" data-id="element-153">
            {['Sin pensar', 'Sin medir', 'Sin reglas rígidas'].map((tag, i) => <motion.span key={tag} initial={{
            opacity: 0,
            scale: 0.9
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.4 + i * 0.1
          }} className="px-4 py-2 bg-sage/10 text-sage-dark rounded-full text-sm font-medium border border-sage/20" data-id="element-154">
                {tag}
              </motion.span>)}
          </div>
        </motion.div>
      </div>
    </section>;
}